import { AvailabilityServiceImpl } from "./availability-service";
import "./availability-constants";
import "./availability-models";
import { CantileverStateConstants, ModalityConstants } from "./availability-constants";
import { ChannelsConstants } from "../agent-channels/channels-constants";

let availabilityModule = angular.module("sdApp.availability", []);
availabilityModule
  .constant("cantileverStateConstants", new CantileverStateConstants(new ChannelsConstants()))
  .constant("modalityConstants", new ModalityConstants(new ChannelsConstants()))
  .service("sdkAvailabilityService", AvailabilityServiceImpl);

export default availabilityModule;
